export const alphanumericSort = (a: string, b: string): number => {
  const result = new Intl.Collator('en', { numeric: true }).compare(a, b)
  return result
}
